import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { cn } from '../utils/classes';
/**
 * Generic ring spinner for small utilitarian affordances (e.g. button
 * loading states). For branded loading surfaces — route-level states,
 * content panes, thumbnails — prefer `BrandSpinner`.
 */
export const Spinner = t0 => {
  const $ = _c(25);
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      size: t1,
      color: t2,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const size = t1 === undefined ? "md" : t1;
  const color = t2 === undefined ? "default" : t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: 16,
      height: 16,
      viewBox: "0 0 16 16",
      strokeWidth: 2,
      circleProps: {
        cx: 8,
        cy: 8,
        r: 7,
        opacity: 0.4
      },
      pathD: "M8 1 A7 7 0 0 1 15 8"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      strokeWidth: 3,
      circleProps: {
        cx: 12,
        cy: 12,
        r: 10.5,
        opacity: 0.4
      },
      pathD: "M12 1.5 A10.5 10.5 0 0 1 22.5 12"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      width: 32,
      height: 32,
      viewBox: "0 0 32 32",
      strokeWidth: 4,
      circleProps: {
        cx: 16,
        cy: 16,
        r: 14,
        opacity: 0.4
      },
      pathD: "M16 2 A14 14 0 0 1 30 16"
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      sm: t3,
      md: t4,
      lg: t5,
      xl: {
        width: 64,
        height: 64,
        viewBox: "0 0 64 64",
        strokeWidth: 5,
        circleProps: {
          cx: 32,
          cy: 32,
          r: 29.5,
          opacity: 0.4
        },
        pathD: "M32 2 A30 30 0 0 1 62 32"
      }
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const svgProps = t6;
  const {
    width,
    height,
    viewBox,
    strokeWidth,
    circleProps,
    pathD
  } = svgProps[size];
  const strokeColor = color === "inverse" ? "#FFFFFF" : "#6366F1";
  let t7;
  if ($[9] !== className) {
    t7 = cn("animate-spin", className);
    $[9] = className;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== circleProps) {
    t8 = <circle {...circleProps} />;
    $[11] = circleProps;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== pathD) {
    t9 = <path d={pathD} fill="none" />;
    $[13] = pathD;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== height || $[16] !== props || $[17] !== strokeColor || $[18] !== strokeWidth || $[19] !== t7 || $[20] !== t8 || $[21] !== t9 || $[22] !== viewBox || $[23] !== width) {
    t10 = <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} stroke={strokeColor} strokeWidth={strokeWidth} fill="none" className={t7} {...props}>{t8}{t9}</svg>;
    $[15] = height;
    $[16] = props;
    $[17] = strokeColor;
    $[18] = strokeWidth;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = viewBox;
    $[23] = width;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};